export default (theme) => ({
  checkBoxContainer: {
    marginBottom: 3,
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  recordName: {
    fontSize: 14,
    fontWeight: "bold",
  },
});
